// src/services/paymentApi.js
import axios from 'axios';

// Use your existing API base but for payment routes specifically
export const PAYMENT_API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://ymytutoring.com/api/client';

export const paymentApi = axios.create({
  baseURL: PAYMENT_API_BASE,
  headers: { 
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// No auth interceptor needed for payment routes - they're public

export const paymentService = {
  // Get payment data for display
  getPaymentData: async (token) => {
    try {
      const response = await paymentApi.get(`/payment/${token}`);
      return { success: true, data: response.data.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to load payment information',
        errorType: error.response?.data?.error_type || 'UNKNOWN_ERROR'
      };
    }
  },

  // Process payment (initiate MyFatoorah)
  processPayment: async (token) => {
    try {
      const response = await paymentApi.post(`/payment/${token}/process`);
      return { success: true, data: response.data.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Payment processing failed',
        errorType: error.response?.data?.error_type || 'PAYMENT_ERROR'
      };
    }
  },

  // Check payment status
  getPaymentStatus: async (token) => {
    try {
      const response = await paymentApi.get(`/payment/${token}/status`);
      return { success: true, data: response.data.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to check payment status'
      };
    }
  }
};